import Vue from 'vue'
import Hammocks from './hammocks'
import FrontPage from './front-page'
import Gifts from './gifts'
import Hotel from './hotel'

Vue.component('hammocks', Hammocks)
Vue.component('front-page', FrontPage)
Vue.component('gifts', Gifts)
Vue.component('hotel', Hotel)